import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

// Material UI components
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";

// Custom Components
import Filter from "@Components/Filter";
import Table from "@Components/Table";
import Modal from "@Components/Modal";
import { fetchDataFromApi } from "utils";
import eightAxios from "configs/axiosConfig";
import Notify from "@Components/Notify";
import VisibilityIcon from "@material-ui/icons/Visibility";


import {
  BO_USER_URL,
  ESTATE_FETCH_URL,
  REGION_FETCH_URL,
  ROLES_URL,
  ZONE_FETCH_URL,
} from "configs/constants";
import { LIST_ROLE_URL, ROLE_BULK_ASSIGN_URL } from "configs/constants";
import { useTranslation } from "react-i18next";
import { COMPANY_FETCH_URL } from "configs/constants";

let model = [
  { id: "employee_id", label: "Employee ID", type: "string" },
  { id: "name", label: "Name", type: "string" },
  { id: "role_name", label: "Role", type: "string" },
  { id: "mobile_number", label: "Mobile Number", type: "string" },
  { id: "id_number", label: "ID Number", type: "string" },
  { id: "designation", label: "Designation", type: "string" },
  { id: "status", label: "Status", type: "string" },
  { id: "estate", label: "Estate Name", type: "string" },
];

const actions = ["delete"];

const isBOUserDelete = true;


const SendSms = (props) => {
  const { messageBody, setMessageBody } = props;
  return (
    <Grid container direction="column" spacing={2}>
      <Grid item>
        <div>{messageBody}</div>
      </Grid>
      <Grid item>
        <TextField
          onChange={(event) => {
            setMessageBody(event.target.value);
          }}
          variant="outlined"
          row={5}
          multiline
          fullWidth
        />
      </Grid>
    </Grid>
  );
};
SendSms.propTypes = {
  messageBody: PropTypes.string,
  setMessageBody: PropTypes.func,
};

const SelectRole = (props) => {
  const { t } = useTranslation();
 
  const { roles, setRole } = props;
  const handleChange = (event) => {
    setRole(event.target.value);
  };
  return (
    <Grid container direction="column" spacing={5}>
      <Grid item>
        <form>
          <select name="role" className="form-control" onChange={handleChange}>
            <option>{t("Select Role")}</option>
            {roles.map(({ id, emp_id, name }) => (
              <option value={id} key={id} data-id={emp_id}>
                {name}
              </option>
            ))}
          </select>
        </form>
      </Grid>
    </Grid>
  );
};
SelectRole.propTypes = {
  roles: PropTypes.object,
  setRole: PropTypes.func,
};

const getZoneValues = (e,setDisableRegion) => {
//  if (!e || e.length === 0) {
  if (!e || e.length === 0 || e.label == "N/A") {
    setDisableRegion(true);
  }
  else {
    setDisableRegion(false);
  }
  
};
const getRegionValues = (e,setDisableEstate) => {
  if (!e || e.length === 0) {
    setDisableEstate(true);
  }
  else {
    setDisableEstate(false);
  }
  
};



export default function UserList() {
  // Use a state to store the table's selected values and also provide a callback function
  const { t } = useTranslation();
  const [disableRegion, setDisableRegion] = useState(true);
  const [disableEstate, setDisableEstate] = useState(true);
  const [selected, setSelected] = useState([]);
  const [filterValues, setFilterValues] = useState({});
  const [roleAssignment, setRoleAssignment] = useState(false);
  const [roles, setRoles] = useState([]);
  const [filterRoles, setFilterRoles] = useState([]);
  const [role, setRole] = useState("");
  const [refresh, setRefresh] = useState(false);
  const [filtersApplied, setFiltersApplied] = useState(false);
  const [disableZone, setDisableZone] = useState(true);


  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });

  const getCompanyValues = (e, setDisableZone) => {
    if (!e || e.length === 0) {
      setDisableZone(true);
    }
    else {
      setDisableZone(false);
    }
  
  };

  const [modalFields, setModalFields] = useState({
    title: "Role Assignment",
    isOpen: false,
    body: null,
    confirmButtonLabel: "Save",
    resetModalBodyState: () => setRoles([]),
    bodyMessage: null,
  });

  const filterFields = [
    {
      type: "reactselect",
      label: "Status",
      name: "status",
      outerOptions: [
        { id: "Active", name: "Active" },
        { id: "Inactive", name: "Inactive" },
      ],
    },
    {
      type: "input",
      label: "Employee ID",
      name: "employee_id",
    },
    {
      type: "input",
      label: "Name",
      name: "name",
    },
    {
      type: "input",
      label: "Mobile Number",
      name: "mobile_number",
    },
    {
      type: "input",
      label: "ID Number",
      name: "id_number",
    },
    {
      type: "reactselect",
      label: "Role",
      name: "role",
      proxyUrl: ROLES_URL,
      paginated: false,
      isPaginationEnabled: false,
      discardOptionsByName: ["Worker"],
    },
    {
      type: "input",
      label: "Designation",
      name: "designation",
    },
    {
      type: "reactselect",
      name: "company",
      label: "Company",
      proxyUrl: COMPANY_FETCH_URL,
      getValue: (e) => getCompanyValues(e, setDisableZone),
      paginated: true,
  
  
    },
    {
      type: "reactselect",
      name: "zone",
      label: "Zone",
      proxyUrl: ZONE_FETCH_URL,
      getValue: (e) => getZoneValues(e, setDisableRegion),
      paginated: true,
      disabled:disableZone,
      optionsDependsOn: "company",
    },
    {
      type: "reactselect",
      name: "region",
      label: "Region",
      proxyUrl: REGION_FETCH_URL,
      paginated: true,
      disabled:disableRegion,
      getValue: (e) => getRegionValues(e, setDisableEstate),
      optionsDependsOn: "zone",
    },
    {
      type: "reactselect",
      name: "estate",
      label: "Estate",
      proxyUrl: ESTATE_FETCH_URL,
      paginated: true,
      disabled:disableEstate,
      optionsDependsOn: "region",
    },
    {
      type: "reactselect",
      name: "api",
      label: "API",
      outerOptions: [
        { id: "0", name: "No" },
        { id: "1", name: "Yes" },
      ],
      paginated: true,
    },
  ];
  const pageNumberDropdown = true;


  useEffect(() => {
    fetchDataFromApi(ROLES_URL, setFilterRoles, true);
  }, []);

  useEffect(() => {
    const workerRole = filterRoles.find((role) => role.name === "Worker");
    if (filterRoles.includes(workerRole)) {
      setFilterRoles(filterRoles.filter((item) => item.name !== "Worker"));
    }
  }, [filterRoles]);

  useEffect(() => {
    setRefresh(false);
  }, [refresh]);

  useEffect(() => {
    fetchDataFromApi(LIST_ROLE_URL, setRoles, true);
    if (roleAssignment) {
      setModalFields({
        ...modalFields,
        body: <SelectRole roles={roles} setRole={setRole} />,
        onConfirm: () => {
          const body = {
            ids: selected,
            role: role,
            filter_params: filterValues,
          };
          eightAxios
            .patch(ROLE_BULK_ASSIGN_URL, body)
            .then((response) => {
              setRefresh(true);
              setRoleAssignment(false);
              console.log(response.data);
            })
            .catch((error) => {
              setRefresh(true);
              setRoleAssignment(false);
              console.error(error);
            });
          setModalFields({
            ...modalFields,
            isOpen: false,
          });
        },
      });
    }
  }, [roleAssignment, role]);

  const filterInitialValues = {
    status: "",
    company: "",
    zone: "",
    region: "",
    estate: "",
    block: "",
    name: "",
    designation: "",
    mobile_number: "",
    id_number: "",
    employee_id: "",
  };

  // Action buttons props
  const actionBarButtons = [
    {
      color: "primary",
      buttonLabel: "Assign Role",
      onClick: () => {
        if (!selected.length) {
          setNotify({
            isOpen: true,
            message: "Please select one or more users to assign role",
            type: "error",
          });
        } else {
          setRoleAssignment(true);
          setModalFields({
            ...modalFields,
            isOpen: true,
          });
        }
      },
    },
  ];

  const onFilterRequest = (values) => {
    setFiltersApplied(true); 

    let filterObj = {};
    for (const [key, value] of Object.entries(values)) {
      if (value !== null && value !== "") {
        filterObj[key] = value;
      }
    }
    setFilterValues(filterObj);
  };
  const clearFilter =()=>{
    filterInitialValues.status = null
    location.reload();
   }
  return (
    <div>
      <Filter
        initialValues={filterInitialValues}
        filterFields={filterFields}
        onSubmit={onFilterRequest}
        onClear={clearFilter}



      />
{filtersApplied ? ( 

      <Table
        proxyURL={BO_USER_URL}
        model={model}
        refresh={refresh}
        actions={actions}
        excelExport={{ fileName: "BackOfficeUserReport" }}
        filterValues={filterValues}
        actionBarButtons={actionBarButtons}
        isBOUserDelete={isBOUserDelete}
        noFilter
        pageNumberDropdown={pageNumberDropdown}
        check
        selected={selected}
        setSelected={setSelected}
      />
      ) : (
        <Table
        proxyURL={null}
        model={model}
        refresh={refresh}
        actions={actions}
        excelExport={{ fileName: "BackOfficeUserReport" }}
        filterValues={filterValues}
        actionBarButtons={actionBarButtons}
        isBOUserDelete={isBOUserDelete}
        noFilter
        pageNumberDropdown={pageNumberDropdown}
        check
        selected={selected}
        setSelected={setSelected}
      />
      )}

      <Modal modalFields={modalFields} setModalFields={setModalFields} />
      <Notify notify={notify} setNotify={setNotify} />
    </div>
  );
}
